import React from "react";

// @mui/icons-material
import TrendingUp from "@mui/icons-material/TrendingUp";
// core components
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardBody from "components/Card/CardBody.js";
import Info from "components/Typography/Info.js";
import Success from "components/Typography/Success.js";
import Danger from "components/Typography/Danger.js";
import styles from "../../../../services/ServicesSections.module.scss";





export default function SectionSimilarStories() {
  const classes = styles;
  return (
    <div className={classes.section}>
      <div className={classes.container}>
        
      </div>
    </div>
  );
}
